import { FC, ReactElement } from 'react'

export const WrapLogin: FC = ({ children }): ReactElement => (
  <div className="form">
    <div className="wrapper">{children}</div>
  </div>
)
